import { Fragment } from 'react/jsx-runtime'
import { Dir } from '../../interface'
import { findPath } from '../../utils'
import { LinkItem, PathText, Wrapper } from './atoms'
import { Arrow } from './svg/arrow'
import { Link } from 'gatsby'

interface Props {
  dirs: Dir[]
  currentSlug: string
  currentName: string
  hideHeadFooter?: boolean
  hideInMobile?: boolean
  tight?: boolean
  noHref?: boolean
}

export const Breadcrumb = ({
  dirs,
  currentSlug,
  currentName,
  hideHeadFooter,
  hideInMobile,
  tight,
  noHref,
}: Props) => {
  const paths = findPath(dirs, currentSlug)

  return (
    <Wrapper $hideInMobile={hideInMobile} $tight={tight}>
      {!hideHeadFooter && (
        <LinkItem as={noHref ? 'div' : Link} to='/support'>
          Support
        </LinkItem>
      )}
      {paths?.map((item, index) => (
        <Fragment key={index}>
          {!(hideHeadFooter && index === 0) && <Arrow />}
          <LinkItem
            as={noHref ? 'div' : Link}
            to={`/support/${paths
              .slice(0, index + 1)
              .map((item) => item.slug)
              .join('/')}`}
          >
            {item.name}
          </LinkItem>
        </Fragment>
      ))}
      {!hideHeadFooter && (
        <>
          <Arrow />
          <PathText>{currentName}</PathText>
        </>
      )}
    </Wrapper>
  )
}
